// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/currency_codes.proto (package squareup.common, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumValueOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import { file_squareup_objc_objc } from "../objc/objc_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/currency_codes.proto.
 */
export const file_squareup_common_currency_codes: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_descriptor, file_squareup_objc_objc]);

/**
 * @generated from message squareup.common.Denominations
 */
export type Denominations = Message<"squareup.common.Denominations"> & {
  /**
   * @generated from field: repeated int32 banknote_cents = 1;
   */
  banknoteCents: number[];

  /**
   * @generated from field: repeated int32 coin_cents = 2;
   */
  coinCents: number[];
};

/**
 * Describes the message squareup.common.Denominations.
 * Use `create(DenominationsSchema)` to create a new message.
 */
export const DenominationsSchema: GenMessage<Denominations> = /*@__PURE__*/
  messageDesc(file_squareup_common_currency_codes, 0);

/**
 * These rounding modes match with NSRoundingMode in NSDecimal.h
 *
 * @generated from enum squareup.common.RoundingMode
 */
export enum RoundingMode {
  /**
   * Round up on a tie.
   *
   * @generated from enum value: PLAIN = 0;
   */
  PLAIN = 0,

  /**
   * Always round down == truncate.
   *
   * @generated from enum value: DOWN = 1;
   */
  DOWN = 1,

  /**
   * Always up.
   *
   * @generated from enum value: UP = 2;
   */
  UP = 2,

  /**
   * On a tie round so the last digit is even.
   *
   * @generated from enum value: BANKERS = 3;
   */
  BANKERS = 3,

  /**
   * Round down on a tie.
   *
   * @generated from enum value: DOWN_ON_HALF = 4;
   */
  DOWN_ON_HALF = 4,
}

/**
 * Describes the enum squareup.common.RoundingMode.
 */
export const RoundingModeSchema: GenEnum<RoundingMode> = /*@__PURE__*/
  enumDesc(file_squareup_common_currency_codes, 0);

/**
 * *
 * ISO-4217 Currency Codes
 * http://www.currency-iso.org/dl_iso_table_a1.xml
 * Names are the alpha-3 code, ordinals are the numeric code.
 *
 * @generated from enum squareup.common.CurrencyCode
 */
export enum CurrencyCode {
  /**
   * @generated from enum value: AED = 784;
   */
  AED = 784,

  /**
   * @generated from enum value: AFN = 971;
   */
  AFN = 971,

  /**
   * @generated from enum value: ALL = 8;
   */
  ALL = 8,

  /**
   * @generated from enum value: AMD = 51;
   */
  AMD = 51,

  /**
   * @generated from enum value: ANG = 532;
   */
  ANG = 532,

  /**
   * @generated from enum value: AOA = 973;
   */
  AOA = 973,

  /**
   * @generated from enum value: ARS = 32;
   */
  ARS = 32,

  /**
   * @generated from enum value: AUD = 36;
   */
  AUD = 36,

  /**
   * @generated from enum value: AWG = 533;
   */
  AWG = 533,

  /**
   * @generated from enum value: AZN = 944;
   */
  AZN = 944,

  /**
   * @generated from enum value: BAM = 977;
   */
  BAM = 977,

  /**
   * @generated from enum value: BBD = 52;
   */
  BBD = 52,

  /**
   * @generated from enum value: BDT = 50;
   */
  BDT = 50,

  /**
   * @generated from enum value: BGN = 975;
   */
  BGN = 975,

  /**
   * @generated from enum value: BHD = 48;
   */
  BHD = 48,

  /**
   * @generated from enum value: BIF = 108;
   */
  BIF = 108,

  /**
   * @generated from enum value: BMD = 60;
   */
  BMD = 60,

  /**
   * @generated from enum value: BND = 96;
   */
  BND = 96,

  /**
   * @generated from enum value: BOB = 68;
   */
  BOB = 68,

  /**
   * @generated from enum value: BOV = 984;
   */
  BOV = 984,

  /**
   * @generated from enum value: BRL = 986;
   */
  BRL = 986,

  /**
   * @generated from enum value: BSD = 44;
   */
  BSD = 44,

  /**
   * @generated from enum value: BTN = 64;
   */
  BTN = 64,

  /**
   * @generated from enum value: BWP = 72;
   */
  BWP = 72,

  /**
   * @generated from enum value: BYR = 974;
   */
  BYR = 974,

  /**
   * @generated from enum value: BZD = 84;
   */
  BZD = 84,

  /**
   * @generated from enum value: CAD = 124;
   */
  CAD = 124,

  /**
   * @generated from enum value: CDF = 976;
   */
  CDF = 976,

  /**
   * @generated from enum value: CHE = 947;
   */
  CHE = 947,

  /**
   * @generated from enum value: CHF = 756;
   */
  CHF = 756,

  /**
   * @generated from enum value: CHW = 948;
   */
  CHW = 948,

  /**
   * @generated from enum value: CLF = 990;
   */
  CLF = 990,

  /**
   * @generated from enum value: CLP = 152;
   */
  CLP = 152,

  /**
   * @generated from enum value: CNY = 156;
   */
  CNY = 156,

  /**
   * @generated from enum value: COP = 170;
   */
  COP = 170,

  /**
   * @generated from enum value: COU = 970;
   */
  COU = 970,

  /**
   * @generated from enum value: CRC = 188;
   */
  CRC = 188,

  /**
   * @generated from enum value: CUC = 931;
   */
  CUC = 931,

  /**
   * @generated from enum value: CUP = 192;
   */
  CUP = 192,

  /**
   * @generated from enum value: CVE = 132;
   */
  CVE = 132,

  /**
   * @generated from enum value: CZK = 203;
   */
  CZK = 203,

  /**
   * @generated from enum value: DJF = 262;
   */
  DJF = 262,

  /**
   * @generated from enum value: DKK = 208;
   */
  DKK = 208,

  /**
   * @generated from enum value: DOP = 214;
   */
  DOP = 214,

  /**
   * @generated from enum value: DZD = 12;
   */
  DZD = 12,

  /**
   * @generated from enum value: EGP = 818;
   */
  EGP = 818,

  /**
   * @generated from enum value: ERN = 232;
   */
  ERN = 232,

  /**
   * @generated from enum value: ETB = 230;
   */
  ETB = 230,

  /**
   * @generated from enum value: EUR = 978;
   */
  EUR = 978,

  /**
   * @generated from enum value: FJD = 242;
   */
  FJD = 242,

  /**
   * @generated from enum value: FKP = 238;
   */
  FKP = 238,

  /**
   * @generated from enum value: GBP = 826;
   */
  GBP = 826,

  /**
   * @generated from enum value: GEL = 981;
   */
  GEL = 981,

  /**
   * @generated from enum value: GHS = 936;
   */
  GHS = 936,

  /**
   * @generated from enum value: GIP = 292;
   */
  GIP = 292,

  /**
   * @generated from enum value: GMD = 270;
   */
  GMD = 270,

  /**
   * @generated from enum value: GNF = 324;
   */
  GNF = 324,

  /**
   * @generated from enum value: GTQ = 320;
   */
  GTQ = 320,

  /**
   * @generated from enum value: GYD = 328;
   */
  GYD = 328,

  /**
   * @generated from enum value: HKD = 344;
   */
  HKD = 344,

  /**
   * @generated from enum value: HNL = 340;
   */
  HNL = 340,

  /**
   * @generated from enum value: HRK = 191;
   */
  HRK = 191,

  /**
   * @generated from enum value: HTG = 332;
   */
  HTG = 332,

  /**
   * @generated from enum value: HUF = 348;
   */
  HUF = 348,

  /**
   * @generated from enum value: IDR = 360;
   */
  IDR = 360,

  /**
   * @generated from enum value: ILS = 376;
   */
  ILS = 376,

  /**
   * @generated from enum value: INR = 356;
   */
  INR = 356,

  /**
   * @generated from enum value: IQD = 368;
   */
  IQD = 368,

  /**
   * @generated from enum value: IRR = 364;
   */
  IRR = 364,

  /**
   * @generated from enum value: ISK = 352;
   */
  ISK = 352,

  /**
   * @generated from enum value: JMD = 388;
   */
  JMD = 388,

  /**
   * @generated from enum value: JOD = 400;
   */
  JOD = 400,

  /**
   * @generated from enum value: JPY = 392;
   */
  JPY = 392,

  /**
   * @generated from enum value: KES = 404;
   */
  KES = 404,

  /**
   * @generated from enum value: KGS = 417;
   */
  KGS = 417,

  /**
   * @generated from enum value: KHR = 116;
   */
  KHR = 116,

  /**
   * @generated from enum value: KMF = 174;
   */
  KMF = 174,

  /**
   * @generated from enum value: KPW = 408;
   */
  KPW = 408,

  /**
   * @generated from enum value: KRW = 410;
   */
  KRW = 410,

  /**
   * @generated from enum value: KWD = 414;
   */
  KWD = 414,

  /**
   * @generated from enum value: KYD = 136;
   */
  KYD = 136,

  /**
   * @generated from enum value: KZT = 398;
   */
  KZT = 398,

  /**
   * @generated from enum value: LAK = 418;
   */
  LAK = 418,

  /**
   * @generated from enum value: LBP = 422;
   */
  LBP = 422,

  /**
   * @generated from enum value: LKR = 144;
   */
  LKR = 144,

  /**
   * @generated from enum value: LRD = 430;
   */
  LRD = 430,

  /**
   * @generated from enum value: LSL = 426;
   */
  LSL = 426,

  /**
   * @generated from enum value: LTL = 440;
   */
  LTL = 440,

  /**
   * @generated from enum value: LVL = 428;
   */
  LVL = 428,

  /**
   * @generated from enum value: LYD = 434;
   */
  LYD = 434,

  /**
   * @generated from enum value: MAD = 504;
   */
  MAD = 504,

  /**
   * @generated from enum value: MDL = 498;
   */
  MDL = 498,

  /**
   * @generated from enum value: MGA = 969;
   */
  MGA = 969,

  /**
   * @generated from enum value: MKD = 807;
   */
  MKD = 807,

  /**
   * @generated from enum value: MMK = 104;
   */
  MMK = 104,

  /**
   * @generated from enum value: MNT = 496;
   */
  MNT = 496,

  /**
   * @generated from enum value: MOP = 446;
   */
  MOP = 446,

  /**
   * @generated from enum value: MRO = 478;
   */
  MRO = 478,

  /**
   * @generated from enum value: MUR = 480;
   */
  MUR = 480,

  /**
   * @generated from enum value: MVR = 462;
   */
  MVR = 462,

  /**
   * @generated from enum value: MWK = 454;
   */
  MWK = 454,

  /**
   * @generated from enum value: MXN = 484;
   */
  MXN = 484,

  /**
   * @generated from enum value: MXV = 979;
   */
  MXV = 979,

  /**
   * @generated from enum value: MYR = 458;
   */
  MYR = 458,

  /**
   * @generated from enum value: MZN = 943;
   */
  MZN = 943,

  /**
   * @generated from enum value: NAD = 516;
   */
  NAD = 516,

  /**
   * @generated from enum value: NGN = 566;
   */
  NGN = 566,

  /**
   * @generated from enum value: NIO = 558;
   */
  NIO = 558,

  /**
   * @generated from enum value: NOK = 578;
   */
  NOK = 578,

  /**
   * @generated from enum value: NPR = 524;
   */
  NPR = 524,

  /**
   * @generated from enum value: NZD = 554;
   */
  NZD = 554,

  /**
   * @generated from enum value: OMR = 512;
   */
  OMR = 512,

  /**
   * @generated from enum value: PAB = 590;
   */
  PAB = 590,

  /**
   * @generated from enum value: PEN = 604;
   */
  PEN = 604,

  /**
   * @generated from enum value: PGK = 598;
   */
  PGK = 598,

  /**
   * @generated from enum value: PHP = 608;
   */
  PHP = 608,

  /**
   * @generated from enum value: PKR = 586;
   */
  PKR = 586,

  /**
   * @generated from enum value: PLN = 985;
   */
  PLN = 985,

  /**
   * @generated from enum value: PYG = 600;
   */
  PYG = 600,

  /**
   * @generated from enum value: QAR = 634;
   */
  QAR = 634,

  /**
   * @generated from enum value: RON = 946;
   */
  RON = 946,

  /**
   * @generated from enum value: RSD = 941;
   */
  RSD = 941,

  /**
   * @generated from enum value: RUB = 643;
   */
  RUB = 643,

  /**
   * @generated from enum value: RWF = 646;
   */
  RWF = 646,

  /**
   * @generated from enum value: SAR = 682;
   */
  SAR = 682,

  /**
   * @generated from enum value: SBD = 90;
   */
  SBD = 90,

  /**
   * @generated from enum value: SCR = 690;
   */
  SCR = 690,

  /**
   * @generated from enum value: SDG = 938;
   */
  SDG = 938,

  /**
   * @generated from enum value: SEK = 752;
   */
  SEK = 752,

  /**
   * @generated from enum value: SGD = 702;
   */
  SGD = 702,

  /**
   * @generated from enum value: SHP = 654;
   */
  SHP = 654,

  /**
   * @generated from enum value: SLL = 694;
   */
  SLL = 694,

  /**
   * @generated from enum value: SOS = 706;
   */
  SOS = 706,

  /**
   * @generated from enum value: SRD = 968;
   */
  SRD = 968,

  /**
   * @generated from enum value: SSP = 728;
   */
  SSP = 728,

  /**
   * @generated from enum value: STD = 678;
   */
  STD = 678,

  /**
   * @generated from enum value: SVC = 222;
   */
  SVC = 222,

  /**
   * @generated from enum value: SYP = 760;
   */
  SYP = 760,

  /**
   * @generated from enum value: SZL = 748;
   */
  SZL = 748,

  /**
   * @generated from enum value: THB = 764;
   */
  THB = 764,

  /**
   * @generated from enum value: TJS = 972;
   */
  TJS = 972,

  /**
   * @generated from enum value: TMT = 934;
   */
  TMT = 934,

  /**
   * @generated from enum value: TND = 788;
   */
  TND = 788,

  /**
   * @generated from enum value: TOP = 776;
   */
  TOP = 776,

  /**
   * @generated from enum value: TRY = 949;
   */
  TRY = 949,

  /**
   * @generated from enum value: TTD = 780;
   */
  TTD = 780,

  /**
   * @generated from enum value: TWD = 901;
   */
  TWD = 901,

  /**
   * @generated from enum value: TZS = 834;
   */
  TZS = 834,

  /**
   * @generated from enum value: UAH = 980;
   */
  UAH = 980,

  /**
   * @generated from enum value: UGX = 800;
   */
  UGX = 800,

  /**
   * @generated from enum value: USD = 840;
   */
  USD = 840,

  /**
   * @generated from enum value: USN = 997;
   */
  USN = 997,

  /**
   * @generated from enum value: USS = 998;
   */
  USS = 998,

  /**
   * @generated from enum value: UYI = 940;
   */
  UYI = 940,

  /**
   * @generated from enum value: UYU = 858;
   */
  UYU = 858,

  /**
   * @generated from enum value: UZS = 860;
   */
  UZS = 860,

  /**
   * @generated from enum value: VEF = 937;
   */
  VEF = 937,

  /**
   * @generated from enum value: VND = 704;
   */
  VND = 704,

  /**
   * @generated from enum value: VUV = 548;
   */
  VUV = 548,

  /**
   * @generated from enum value: WST = 882;
   */
  WST = 882,

  /**
   * @generated from enum value: XAF = 950;
   */
  XAF = 950,

  /**
   * @generated from enum value: XAG = 961;
   */
  XAG = 961,

  /**
   * @generated from enum value: XAU = 959;
   */
  XAU = 959,

  /**
   * @generated from enum value: XBA = 955;
   */
  XBA = 955,

  /**
   * @generated from enum value: XBB = 956;
   */
  XBB = 956,

  /**
   * @generated from enum value: XBC = 957;
   */
  XBC = 957,

  /**
   * @generated from enum value: XBD = 958;
   */
  XBD = 958,

  /**
   * @generated from enum value: XCD = 951;
   */
  XCD = 951,

  /**
   * @generated from enum value: XDR = 960;
   */
  XDR = 960,

  /**
   * @generated from enum value: XOF = 952;
   */
  XOF = 952,

  /**
   * @generated from enum value: XPD = 964;
   */
  XPD = 964,

  /**
   * @generated from enum value: XPF = 953;
   */
  XPF = 953,

  /**
   * @generated from enum value: XPT = 962;
   */
  XPT = 962,

  /**
   * @generated from enum value: XTS = 963;
   */
  XTS = 963,

  /**
   * @generated from enum value: XXX = 999;
   */
  XXX = 999,

  /**
   * @generated from enum value: YER = 886;
   */
  YER = 886,

  /**
   * @generated from enum value: ZAR = 710;
   */
  ZAR = 710,

  /**
   * @generated from enum value: ZMK = 894;
   */
  ZMK = 894,

  /**
   * @generated from enum value: ZMW = 967;
   */
  ZMW = 967,

  /**
   * Currency codes not currently in ISO-4217:
   *
   * @generated from enum value: BTC = 1001;
   */
  BTC = 1001,

  /**
   * @generated from enum value: XUS = 1002;
   */
  XUS = 1002,

  /**
   * This is added to the end of the list because Cash Lending services are encoding
   * the ordinal position of the enum instead of the enum codes
   *
   * @generated from enum value: SLE = 925;
   */
  SLE = 925,

  /**
   * @generated from enum value: VES = 928;
   */
  VES = 928,
}

/**
 * Describes the enum squareup.common.CurrencyCode.
 */
export const CurrencyCodeSchema: GenEnum<CurrencyCode> = /*@__PURE__*/
  enumDesc(file_squareup_common_currency_codes, 1);

/**
 * @generated from extension: optional int32 cash_rounding = 54000;
 */
export const cash_rounding: GenExtension<EnumValueOptions, number> = /*@__PURE__*/
  extDesc(file_squareup_common_currency_codes, 0);

/**
 * @generated from extension: optional squareup.common.Denominations denominations = 54001;
 */
export const denominations: GenExtension<EnumValueOptions, Denominations> = /*@__PURE__*/
  extDesc(file_squareup_common_currency_codes, 1);

/**
 * @generated from extension: optional squareup.common.RoundingMode rounding_mode = 54002;
 */
export const rounding_mode: GenExtension<EnumValueOptions, RoundingMode> = /*@__PURE__*/
  extDesc(file_squareup_common_currency_codes, 2);

